import { ReactNode } from 'react'

// Simple component that fills full width and height of its parent and centers the content
export const CenteredContent = ({ children }: { children: ReactNode }) => {
  return <div className="flex items-center justify-center w-full h-full">{children}</div>
}
